import * as React from "react";
import type { SVGProps } from "react";
const SvgReceiptLight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      fill="#90B9FF"
      d="M3.182 2C2.6 2.002 2 2.375 2 3.113v4.37c0 .591.48 1.074 1.067 1.074h.965a.23.23 0 0 0 .228-.229V2.987c0-.662-.53-.989-1.078-.987"
      opacity={0.2}
    />
    <path
      fill="#23F6E7"
      d="M13.361 2.21H4.758a.09.09 0 0 0-.087.066.09.09 0 0 0 .039.103c.319.2.532.555.532.958V14.34c0 .296.24.537.533.537h8.173a.536.536 0 0 0 .534-.537V3.337c0-.62-.505-1.128-1.121-1.128"
    />
  </svg>
);
export default SvgReceiptLight;
